import { render } from "./TestHeader.vue?vue&type=template&id=b48c0a60"
import script from "./TestHeader.vue?vue&type=script&lang=js"
export * from "./TestHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__